import { GENDER_FILTER } from '../constants'
import { FilterRadio } from './filter-radio'

type Props = {
  value: string
  onFilterChange: (value: string) => void
}

export const FilterGender = ({ value, onFilterChange }: Props) => {
  return (
    <FilterRadio
      value={value}
      onFilterChange={onFilterChange}
      items={GENDER_FILTER.map((item) => ({
        value: item.value,
        label: <div className='flex items-center gap-2'>{item.label}</div>,
      }))}
    />
  )
}
